import React from "react";

import { IikoModifierSetTypeDto } from "services/modifierSets/restModels";
import { Checkbox, LabeledField, Select } from "shared/ui";

import { ExternalIdField } from "features/ModifierSets/components/ExternalIdField";
import { IIKO_SET_TYPE_LABELS, NO_IIKO_SET_TYPE } from "features/ModifierSets/constants";
import { ExternalOptionItem } from "features/ModifierSets/types";

import { SectionTitle } from "./styles";

const IIKO_TYPE_OPTIONS = [
    { value: NO_IIKO_SET_TYPE, label: "Не привязан" },
    ...[
        IikoModifierSetTypeDto.PriceSize,
        IikoModifierSetTypeDto.Modifiers,
        IikoModifierSetTypeDto.GroupModifiers,
    ].map((type) => ({ value: type, label: IIKO_SET_TYPE_LABELS[type] })),
];

interface ModifierSetExternalBindingProps {
    iikoType: string;
    onIikoTypeChange: (value: string) => void;
    isCommonCompoundModifier: boolean;
    onCommonCompoundModifierChange: (value: boolean) => void;
    externalId: string;
    onExternalIdChange: (value: string) => void;
    // Группы внешнего меню приезжают только когда набор правят из позиции с привязкой.
    groupOptions: ExternalOptionItem[];
    groupOptionsLoading: boolean;
    locale: string;
}

export const ModifierSetExternalBinding = ({
    iikoType,
    onIikoTypeChange,
    isCommonCompoundModifier,
    onCommonCompoundModifierChange,
    externalId,
    onExternalIdChange,
    groupOptions,
    groupOptionsLoading,
    locale,
}: ModifierSetExternalBindingProps) => (
    <>
        <SectionTitle>Внешнее меню (iiko)</SectionTitle>

        <LabeledField
            label="Тип набора во внешнем меню"
            hint="Нужен, чтобы связать набор с модификаторами внешнего меню"
        >
            <Select value={iikoType} onChange={onIikoTypeChange} options={IIKO_TYPE_OPTIONS} />
        </LabeledField>

        {iikoType !== NO_IIKO_SET_TYPE && (
            <Checkbox
                checked={isCommonCompoundModifier}
                onChange={onCommonCompoundModifierChange}
                label="Общий набор"
                hint="Только для сборных позиций iiko"
            />
        )}

        {iikoType === IikoModifierSetTypeDto.GroupModifiers && (
            <LabeledField label="Группа модификаторов">
                <ExternalIdField
                    value={externalId}
                    onChange={onExternalIdChange}
                    options={groupOptions}
                    loading={groupOptionsLoading}
                    locale={locale}
                />
            </LabeledField>
        )}
    </>
);
